'use client'

import { useState } from 'react'
import { Klarna32 } from '@vinted/payment-icons'
import { Cell, Divider, Icon, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/shared/i18n'
import { ItemPageKlarnaPromoPluginModel } from '@marketplace-web/domain/checkout-payments-options-data'

import KlarnaPromoModal from './components/KlarnaPromoModal'

const ItemPageKlarnaPromoPlugin = ({ showKlarna }: ItemPageKlarnaPromoPluginModel) => {
  const translatePlugin = useTranslate('checkout.payment.klarna.item_page_plugin')
  const [isModalOpen, setIsModalOpen] = useState(false)

  if (!showKlarna) return null

  const icon = <Icon name={Klarna32} aria-hidden="true" testId="payment-method-icon-klarna" />

  const body = (
    <Text as="p" type={Text.Type.Subtitle}>
      {translatePlugin('body')}
      <button type="button" onClick={() => setIsModalOpen(true)}>
        <Text as="span" type={Text.Type.Subtitle} theme="primary" clickable>
          {translatePlugin('more_details')}
        </Text>
      </button>
    </Text>
  )

  return (
    <div data-testid="item-page-klarna-plugin">
      <Spacer size={Spacer.Size.Large} />
      <Divider />
      <Spacer size={Spacer.Size.Large} />
      <Cell styling={Cell.Styling.Tight} prefix={icon} body={body} />
      <Spacer />
      <KlarnaPromoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  )
}

export default ItemPageKlarnaPromoPlugin
